import type { ReadOnlyGameModel } from 'yage/game/GameModel';
import type { Container } from 'pixi.js';
import { CONFIG, VENDING } from '../domain/config.js';
import { tier } from '../domain/airports.js';
import { unlockCost, vendingReady } from '../domain/economy.js';
import { EQUIPMENT, equipmentQuote, type EquipmentKind } from '../domain/equipment.js';
import { state, career, stations, vending } from '../services/world.js';
import { C, label, button, fmt } from './primitives.js';

type Frame = (title: string, height: number) => { p: Container; w: number };
function text(p: Container, value: string, x: number, y: number, width: number, size = 15) { return label(p, value, x, y, size, C.ink, '500', width); }

export function facilityDirectory(g: ReadOnlyGameModel, frame: Frame, visitFacility: (index: number, machine: boolean) => void, showEquipment: () => void) {
        const e = state(g), ss = stations(g), machines = vending(g);
        const facilities = [...tier(e).stations.map(index => ({ index, machine: false })), ...tier(e).vending.map(index => ({ index, machine: true }))];
        const rows = Math.ceil(facilities.length / 2), { p, w } = frame('Airport upgrades', 200 + rows * 116);
        text(p, 'Choose an improvement here at the admin desk. Helpers are hired on their own screen.', 22, 75, w - 44, 14);
        const cell = (w - 54) / 2;
        facilities.forEach(({ index, machine }, n) => {
            const s = ss[index], x = 22 + n % 2 * (cell + 10), y = 143 + Math.floor(n / 2) * 116;
            label(p, machine ? VENDING[index].name : CONFIG.stages[index].name, x, y, 15, C.navy, '800', cell);
            const description = machine
                ? vendingReady(machines[index]) ? 'Improvement ready' : 'Every ten sales unlocks an improvement'
                : !s.unlocked ? `Build · ${fmt(unlockCost(index, e))}` : `${s.lanes} ${CONFIG.stages[index].unit}${s.lanes > 1 ? 's' : ''} · Help is optional`;
            text(p, description, x, y + 24, cell, 12);
            button(p, machine || s.unlocked ? 'Improvements' : 'Visit construction', x, y + 51, cell, 38, () => visitFacility(index, machine), C.teal, 13);
        });
        button(p, 'Captain equipment', 22, 143 + rows * 116, w - 44, 38, showEquipment, C.navy, 14);
    }
export function equipmentCard(g: ReadOnlyGameModel, frame: Frame, kind: EquipmentKind, stage: number, buy: (cost: number) => void) {
        const e = state(g), q = equipmentQuote(e, stations(g), kind, stage);
        if (!q) return;
        const { p, w } = frame(q.name, 400), wait = Math.max(0, Math.ceil((q.until - g.frame) / 60));
        text(p, Number.isFinite(q.cost) ? `Level ${q.level} → ${q.level + 1}` : `Level ${q.level}`, 22, 79, w - 44, 19);
        text(p, q.effect, 22, 118, w - 44, 15);
        text(p, !Number.isFinite(q.cost) ? 'Fully upgraded.' : wait ? `${wait}s of airport play remaining. Close this screen to continue.` : `Upgrade price: ${fmt(q.cost)} bills · wallet: ${fmt(career(g).money)}`, 22, 189, w - 44, 15);
        const ready = Number.isFinite(q.cost) && !wait && career(g).money >= q.cost;
        button(p, wait ? `Ready in ${wait}s` : !Number.isFinite(q.cost) ? 'Maximum level' : career(g).money < q.cost ? `Need ${fmt(q.cost - career(g).money)} more bills` : `Buy upgrade · ${fmt(q.cost)}`, 22, 265, w - 44, 48, () => {
            if (!ready) return;
            buy(q.cost);
        }, ready ? C.teal : C.muted, 15);
        text(p, 'Only Buy upgrade spends bills. You can leave without buying.', 22, 335, w - 44, 12);
    }
export function equipmentDirectory(g: ReadOnlyGameModel, frame: Frame, visitEquipment: (kind: EquipmentKind) => void) {
        const items = Object.entries(EQUIPMENT).filter(([kind]) => kind !== 'chairs' || tier(state(g)).chairs);
        const { p, w } = frame('Captain equipment', 150 + items.length * 80);
        text(p, 'Review equipment here at the admin desk before buying.', 22, 76, w - 44, 14);
        items.forEach(([kind, item], n) => {
            const q = equipmentQuote(state(g), stations(g), kind as EquipmentKind, -1)!;
            const price = Number.isFinite(q.cost) ? `${fmt(q.cost)} bills` : 'MAX';
            button(p, `${item.name} · ${price}`, 22, 137 + n * 80, w - 44, 48, () => visitEquipment(kind as EquipmentKind), C.teal, 15);
        });
    }
